<template>
  <!-- Sidebar Menu -->
  <nav class="mt-2 nav-flat">
    <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" data-accordion="true" role="menu">
      <li class="nav-item closes-sidebar">
        <router-link :to="{ name: 'home' }" class="nav-link">
          <i class="fas fa-arrow-left nav-icon"></i>
          <p>Torna ad Aziende</p>
        </router-link>
      </li>

      <li v-if="company" class="nav-header text-sm text-truncate" style="text-transform: uppercase; max-width: 238px"
          :title="company.full_name">
        {{ company.full_name }}
      </li>
      <li v-else class="nav-header text-sm text-truncate text-white-50"
          style="text-transform: uppercase; max-width: 238px">
        Caricamento...
      </li>

      <li v-if="company" class="nav-item closes-sidebar">
        <router-link :to="{ name: 'dashboard', params: { company: company.id } }" class="nav-link">
          <i class="fas fa-chart-bar nav-icon"></i>
          <p>Dashboard</p>
        </router-link>
      </li>

      <!-- Disattivato con '&& false' fino a che non sarà attivata la funzionalità -->
      <li v-if="company && false" class="nav-item closes-sidebar">
        <a href="#" class="nav-link">
          <i class="fas fa-sliders-h nav-icon"></i>
          <p>Impostazioni</p>
        </a>
      </li>

      <!-- Disattivato con '&& false' fino a che non sarà attivata la funzionalità -->
      <li v-if="company && userIs('admin') && false" class="nav-item closes-sidebar">
        <a href="#" class="nav-link Placeholder">
          <i class="fas fa-shield-alt nav-icon"></i>
          <p>Amministrazione</p>
        </a>
      </li>
      <li class="nav-header text-sm text-truncate" style="text-transform: uppercase; max-width: 238px">
        Account
      </li>

      <li v-for="(account, index) in accounts" :key="account.id"
        class="account-list-item"
        style="border-top: 1px solid #555; border-bottom: 1px solid #555"
      >
        <Accordion :accordion-id="account.uuid">
          <AccordionItem :accordion-id="account.uuid" item-id="content">
            <template #heading>
              <AccountListItem
                :unseen="unseen[index]"
                :account="account"
              />
            </template>
            <AccountSpecialFolders
              :account="account"
            />
            <Accordion :accordion-id="`${account.uuid}-adrress-books`">
              <AccordionItem :accordion-id="`${account.uuid}-adrress-books`" item-id="adrress-books">
                <template #heading>
                  <i class="fas fa-address-book nav-icon"></i>
                  <p>Rubrica</p>
                </template>
                <li class="nav-item closes-sidebar">
                  <router-link :to="{ name: 'contacts', params: { account: account.uuid } }" class="nav-link">
                    <p>Contatti</p>
                  </router-link>
                </li>
                <li class="nav-item closes-sidebar">
                  <router-link :to="{ name: 'address-books', params: { account: account.uuid } }" class="nav-link">
                    <p>Gruppi</p>
                  </router-link>
                </li>
              </AccordionItem>
            </Accordion>
            <Accordion :accordion-id="`${account.uuid}-tags`">
              <AccordionItem
                :accordion-id="`${account.uuid}-tags`"
                item-id="tags"
              >
                <template #heading>
                  <i class="fas fa-tags nav-icon"></i>
                  Tags
                </template>
                <AccountTags :account-id="account.uuid" />
              </AccordionItem>
            </Accordion>
          </AccordionItem>
        </Accordion>
      </li>

      <li v-if="accounts?.length === 0 && !loading">
        <p class="text-center text-gray">Nessun account associato</p>
      </li>
      <li v-if="accounts?.length === 0 && loading">
        <p class="text-center text-gray">Caricamento in corso...</p>
      </li>
    </ul>
  </nav>
  <Teleport to="body">
    <add-tag-modal />
    <delete-tag-modal />
    <edit-tag-modal />
  </Teleport>
</template>

<script setup>
import bus from "@/bus"
import { ref, inject, Teleport } from 'vue'
import { useRoute } from "vue-router";
import AccountListItem from "./parts/AccountListItem.vue";
import AccountSpecialFolders from "./parts/AccountSpecialFolders.vue";
import AccountTags from "./parts/AccountTags.vue";
import Accordion from "../Accordion/Accordion.vue";
import AccordionItem from "../Accordion/AccordionItem.vue";
import AddTagModal from "@/components/Modals/AddTagModal.vue";
import DeleteTagModal from "@/components/Modals/DeleteTagModal.vue";
import EditTagModal from "../Modals/EditTagModal.vue";
import * as companyService from '@/services/company.service.js'
import { getUnseen, companyData } from '@/services/account.service.js';
import { onMounted } from "vue";
import { onBeforeUnmount } from "vue";

const userIs = inject('userIs');
const route = useRoute();

const companyId = route.params.company;
const loading = ref(false);
const company = ref(null);
const accounts = ref([]);
const unseen = ref([]);
const nodes = ref([]);


/**
 * Updates the unseen data for one or all accounts
 * @param {string} uuid The specific account uuid for which we want to update the data
 */
async function updateUnseenValue(uuid) {
  if (uuid) {
    let index = accounts.value.findIndex(acc => acc.uuid == uuid);
    let val = await getUnseen(uuid);
    unseen.value[index] = val;
    return;
  }

  let res = await companyService.getAccountsUnseenMessages(company.value.id);
  let uuidToIndex = new Map(accounts.value.map((acc, idx) => ([acc.uuid, idx])));

  for (let accountData of res) {
    unseen.value[uuidToIndex.get(accountData.uuid)] = accountData.unseen_count;
  }
}

onMounted(async () => {
  if (route.params.company) {
    let [companyRes, accountsRes] = await Promise.all([
      companyService.get(companyId),
      companyService.getAccounts(companyId)
    ]);

    company.value = companyRes;
    accounts.value = accountsRes;
  } else if (route.params.account) {
    console.log("In route.params.account");
    const data = await companyData(route.params.account);
    company.value = data.company;
    accounts.value = data.accounts;
  }

  await updateUnseenValue();

  // toggleSeen is called passing a uuid
  bus.$on("toggleSeen", updateUnseenValue);
});

onBeforeUnmount(() => {
  bus.$off("toggleSeen", updateUnseenValue);
});
</script>
